<template>
  <div>
    <div class="header_search">
      <Tabs v-model="current" @on-click="changeTabs">
        <TabPane :label="completeLabel" name="complete"></TabPane>
        <TabPane :label="signLabel" name="sign"></TabPane>
        <TabPane :label="giveupLabel" name="giveup"></TabPane>
        <Button class="TabsBtn" type="primary" @click="addMember" slot="extra"
          >新增客户</Button
        >
        <Button
          class="TabsBtn"
          type="primary"
          @click="excelCustomer"
          slot="extra"
          >导出客户Excel</Button
        >
        <Button
          class="TabsBtn"
          type="primary"
          @click="exportReturnRecord"
          slot="extra"
          >导出回访记录</Button
        >
      </Tabs>
      <!-- <div class="topBtn">
                <Button class="item" type="primary" @click="addMember">新增客户</Button>
                <Button class="item" type="primary" @click="excelCustomer">导出客户Excel</Button>
                <Button class="item" type="primary" @click="exportReturnRecord">导出回访记录</Button>
            </div> -->
      <div style="padding: 10px">
        <Form ref="formValidate" :model="formItem" :label-width="90">
          <Row>
            <Col span="4">
              <FormItem label="客户搜索" class="mb-10" prop="keywords">
                <Input
                  v-model="formItem.keywords"
                  placeholder="请输入客户姓名/手机号"
                ></Input>
              </FormItem>
            </Col>
            <Col span="4">
              <FormItem label="录入人" class="mb-10" prop="enter_agent">
                <Input
                  v-model="formItem.enter_agent"
                  placeholder="请输入录入人姓名"
                ></Input>
              </FormItem>
            </Col>
            <Col span="7" v-if="moreSearch">
              <FormItem label="渠道" class="mb-10" prop="enter_department_id">
                <Select
                  v-model="formItem.enter_department_id"
                  placeholder="请选择部门"
                  style="width: 48%"
                  @on-change="changeChannel"
                >
                  <Option
                    v-for="item in departmentList"
                    :key="item.id"
                    :value="item.id"
                    >{{ item.name }}</Option
                  >
                </Select>

                <Select
                  v-model="formItem.enter_channel_id"
                  filterable
                  style="width: 48%"
                  placeholder="请选择渠道"
                >
                  <Option
                    v-for="item in channel"
                    :key="item.id"
                    :value="item.id"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="5">
              <FormItem label="录入时间" class="mb-10" prop="enter_time">
                <DatePicker
                  v-model="formItem.enter_time"
                  type="daterange"
                  :transfer="true"
                  placeholder="请选择"
                  style="display: block"
                  placement="bottom-start"
                ></DatePicker>
              </FormItem>
            </Col>
            <Col span="3" >
              <FormItem label="跟进状态" class="mb-10" prop="follow_status_id">
                <Select
                  v-model="formItem.follow_status_id"
                  placeholder="请选择"
                >
                  <Option
                    v-for="item in baseData.follow_status"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="24" v-if="moreSearch">
              <Col span="4">
                <FormItem label="客户分组" class="mb-10" prop="member_group">
                  <dropCheckBox
                    type="member_group"
                    :checkAllGroup="formItem.member_group"
                    :checkedValue="checkedShowValue"
                    :checkboxData="customerGroudList"
                    placeholder="请选择"
                    @member_group_even="member_group_even"
                  >
                  </dropCheckBox>
                </FormItem>
              </Col>
              <Col span="4">
                <FormItem label="用户类型" class="mb-10" prop="member_type_id">
                  <Select
                    v-model="formItem.member_type_id"
                    placeholder="请选择"
                  >
                    <Option
                      v-for="item in baseData.userType"
                      :value="item.id"
                      :key="item.id"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>

              <Col span="4" v-if="moreSearch">
                <FormItem label="录入方式" class="mb-10" prop="insert_way_id">
                  <Select v-model="formItem.insert_way_id" placeholder="请选择">
                    <Option
                      v-for="item in baseData.insert_way"
                      :value="item.id"
                      :key="item.id"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>

              <Col span="5" v-if="moreSearch" style="margin-bottom: 1px">
                <FormItem label="预产期" class="mb-10" prop="child_birth">
                  <DatePicker
                    v-model="formItem.child_birth"
                    type="daterange"
                    placeholder="请选择"
                    style="display: block"
                  ></DatePicker>
                </FormItem>
              </Col>
              <Col span="4" v-if="moreSearch">
                <FormItem label="跟进结果" class="mb-10" prop="come_status_id">
                  <Select
                    v-model="formItem.come_status_id"
                    placeholder="请选择"
                  >
                    <Option
                      v-for="item in baseData.come_status"
                      :value="item.id"
                      :key="item.id"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
            </Col>
            <Col span="24" v-if="moreSearch">
              <Col span="4" v-if="moreSearch">
                <FormItem label="咨询日期" class="mb-10" prop="consult_time">
                  <DatePicker
                    v-model="formItem.consult_time"
                    type="daterange"
                    placeholder="请选择"
                    style="display: block"
                  ></DatePicker>
                </FormItem>
              </Col>
              <Col span="4" v-if="moreSearch">
                <FormItem label="分配时间" class="mb-10" prop="agent_time">
                  <DatePicker
                    v-model="formItem.agent_time"
                    type="daterange"
                    placeholder="请选择"
                    style="display: block"
                  ></DatePicker>
                </FormItem>
              </Col>
              <Col span="4" v-if="moreSearch">
                <FormItem
                  label="下次回访时间"
                  class="mb-10"
                  :label-width="90"
                  prop="last_visit_time"
                >
                  <DatePicker
                    v-model="formItem.last_visit_time"
                    type="daterange"
                    placeholder="请选择"
                    style="display: block"
                  ></DatePicker>
                </FormItem>
              </Col>
              <Col span="5" v-if="moreSearch">
                <FormItem label="产后客户类型" :label-width="85">
                  <Select
                    v-model="formItem.chankang_type"
                    placeholder="请选择产后客户类型"
                  >
                    <Option
                      v-for="item in baseData.chankang_types"
                      :value="item.id"
                      :key="item.id"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <Col span="4" v-if="moreSearch">
                <Checkbox
                  v-model="formItem.first_enter_id"
                  @on-change="searchFirstTime"
                  style="margin-left: 5px; min-width: 130px"
                  >仅查询首次录入时间</Checkbox
                >
              </Col></Col
            >
            <Col span="8" class="opertionBtn_search">
              <Button
                class="item"
                type="primary"
                @click="search"
                style="margin-left: 5px"
                >查询</Button
              >
              <Button class="item" @click="reset">清空筛选</Button>
              <Button
                class="item"
                type="text"
                @click="screening"
                v-if="!moreSearch"
                style="color: #2d8cf0"
                >更多筛选</Button
              >
              <Button
                class="item"
                type="text"
                @click="packUp"
                v-if="moreSearch"
                style="color: #2d8cf0"
                >收起</Button
              >
              <FormItem class="item" style="margin-bottom: 0" :label-width="0">
                <autoTableItem
                  type="myCustomer"
                  :defaultTable="defaultTable"
                  :autoTableData="autoTableData"
                  placeholder="表格展示项"
                  @autoTableRef="autoTableRef"
                ></autoTableItem>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </div>
    </div>

    <Row class="opertionBtn_search" style="padding: 10px 0">
      <span class="item" style="font-size: 12px"
        >勾选{{ selection.length }}条</span
      >
      <Button class="item" type="primary" size="small" @click="giveUpFollow"
        >放弃跟进</Button
      >
    </Row>
    <div style="width: 100%">
      <Table
        ref="table"
        class="table_style"
        stripe
        :loading="loading"
        border
        :columns="table_columns"
        :data="t_data"
        @on-sort-change="sortTable"
        @on-selection-change="selecstionChange"
        :height="tableHeight"
      ></Table>
      <div style="margin-top: 20px; display: flex; justify-content: flex-end">
        <Page
          :total="pagination.total"
          :page-size="pagination.per_page"
          :current="formItem.page"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="changeLimit"
          :transfer="true"
          :page-size-opts="pageSizeOpts"
        />
      </div>
    </div>
    <!-- 导出 -->
    <customerExcel
      :excelTitle="excelTitle"
      :excelSteps="excelSteps"
      :downloadLink="downloadLink"
      :customerExcelShow="customerExcelShow"
      @customerExcelEven="customerExcelEven"
    >
    </customerExcel>
    <!-- 客户详情 -->
    <Drawer
      :width="80"
      title="客户详情"
      v-model="customerDrawer"
      :mask-closable="false"
      :closable="false"
    >
      <div>
        <div class="customerDetailContent">
          <div class="content">
            <customerInfo
              :customerInfoDetailId="customerInfoDetailId"
              :customerDrawer="customerDrawer"
              @watchUpdate="watchUpdate"
            ></customerInfo>
          </div>
          <div class="content">
            <returnInfo
              :uploadReturn="uploadReturn"
              :customerDrawer="customerDrawer"
              :customerInfoDetailId="customerInfoDetailId"
              :customerGroudList="customerGroudList"
              @watchUpdate="watchUpdate"
            ></returnInfo>
          </div>
        </div>
        <div class="customerDetailContent_opertion_btn">
          <Button type="primary" size="large" @click="relevanceCustomer"
            >关联客户</Button
          >
          <Button type="primary" size="large" @click="applyDiscount"
            >申请折扣</Button
          >
          <Button type="primary" size="large" @click="giveUpFollowDetail"
            >放弃跟进</Button
          >
          <Button type="primary" size="large" @click="paymentIntention"
            >收取意向金</Button
          >
          <Button type="primary" size="large" @click="createOrderTotal"
            >创建预订单</Button
          >
          <Button type="default" size="large" @click="close">收起</Button>
        </div>
      </div>
    </Drawer>
    <!-- 放弃跟进 -->
    <giveUpFollow
      :type="giveUpFollowType"
      :member_ids="member_ids"
      @giveUpFollowEven="giveUpFollowEven"
      :giveUpFollowShow="giveUpFollowShow"
    >
    </giveUpFollow>
    <relevance
      :customerInfoDetailId="customerInfoDetailId"
      :relevanceShow="relevanceShow"
      @relevanceEven="relevanceEven"
    >
    </relevance>
    <!-- 未完成的回访任务提示框 -->
    <Modal
      v-model="showUnfinishedTask"
      :closable="true"
      :mask-closable="true"
      class-name="vertical-center-modal"
    >
      <p slot="header" class="modal_title">
        <span>{{ userName }}的回访任务</span>
      </p>
      <div style="width: 100%; height: 340px; overflow: auto">
        <Row>
          <Col span="24">
            <div
              class="card_wrap"
              v-for="(item, index) in returnTaskList"
              :key="index"
            >
              <Card>
                <p slot="title">回访任务{{ index + 1 }} {{ item.task_name }}</p>
                <div class="card_con">
                  <p>{{ item.desc }}</p>
                  <p>任务日期：{{ item.created_at }}</p>
                </div>
              </Card>
            </div>
          </Col>
        </Row>
      </div>
      <div slot="footer">
        <!-- <Button type="primary" size="large"  @click="handleSubmit('addChannelForm')">确定</Button> -->
        <!-- <Button  size="large"  @click="handleReset('addChannelForm')">取消</Button> -->
      </div>
    </Modal>
  </div>
</template>
<script>
import { mapState } from "vuex";
import dropCheckBox from "@/commonTmp/dropCheckBox"; //多选下拉框
import autoTableItem from "@/commonTmp/CRM/CRM_autoTableItem"; //表格自选项
import customerInfo from "@/commonTmp/CRM/CRM_customerInfo"; //客户基本信息
import returnInfo from "@/commonTmp/CRM/CRM_returnInfo"; //回访信息
import giveUpFollow from "@/commonTmp/CRM/CRM_giveUpFollow"; //放弃跟进
import customerExcel from "@/commonTmp/CRM/CRM_customerExcel"; //客户导出
import relevance from "@/commonTmp/CRM/CRM_relevance"; //关联客户
export default {
  name: "myCustomer",
  components: {
    dropCheckBox,
    customerInfo,
    returnInfo,
    giveUpFollow,
    autoTableItem,
    customerExcel,
    relevance,
  },
  data() {
    return {
      completeLabel: (h) => {
        return h("div", [
          h("span", "待成交"),
          h("Badge", {
            props: {
              count: this.getComplete(),
            },
          }),
        ]);
      },
      signLabel: (h) => {
        return h("div", [
          h("span", "已签单"),
          h("Badge", {
            props: {
              count: this.getSign(),
            },
          }),
        ]);
      },
      giveupLabel: (h) => {
        return h("div", [
          h("span", "已放弃"),
          h("Badge", {
            props: {
              count: this.getGiveup(),
            },
          }),
        ]);
      },
      showUnfinishedTask: false,
      userName: "",
      returnTaskList: [],
      current: "complete",
      complete: 0,
      sign: 0,
      giveup: 0,
      giveUpFollowType: "",
      uploadReturn: false,
      relevanceShow: false,
      isUpdateTable: true,
      excelTitle: "",
      excelSteps: 1,
      downloadLink: "",
      tableHeight: 450,
      pageSizeOpts: [50, 60, 70, 80, 90, 100],
      member_id: "",
      checkedShowValue: "",
      member_ids: [],
      loading: false,
      baseData: baseData,
      moreSearch: false,
      giveUpFollowShow: false,
      customerDrawer: false,
      customerExcelShow: false,
      customerGroudList: [],
      formItem: {
        limit: 50,
        page: 1, //分页
        keywords: "", //客户搜索-过滤客户姓名/手机号
        enter_agent: "", //录入人
        enter_department_id: "", //渠道部门id
        enter_channel_id: "", //渠道id
        member_group: [], //客户分组
        member_type_id: "", //用户类型
        insert_way_id: "", //录入方式
        follow_store_id: "", //跟进人门店
        follow_department_id: "", //跟进人部门
        follow_agent_id: "", //跟进人
        follow_status_id: "", //跟进状态
        child_birth: [], //预产期
        consult_time: [], //咨询时间
        enter_time: [util.getPreDate(90), util.getPreDate(0)], //录入时间
        agent_time: [], //分配时间
        last_visit_time: [], //下次回访时间
        first_enter_id: false, //仅查询首次录入时间
        sort: {},
        come_status_id: "",
        my_member_list_type: "1",
        chankang_type: "",
      },
      table_columns: [],
      defaultTable: [
        "name",
        "phone",
        "member_status",
        "chankang_type_text",
        "follow_store_list",
        "my_store_group_list",
        "member_type",
        "child_birth",
        "consult_time",
        "follow_list",
        "follow_status",
        "allot_time",
        "channel_info_list",
        "agent_name_list",
        "enter_time",
        "come_status",
      ],
      autoTableData: [
        {
          name: "姓名",
          id: "name",
          disabled: true,
        },
        {
          name: "手机号",
          id: "phone",
          disabled: true,
        },
        {
          name: "当前状态",
          id: "member_status",
          disabled: true,
        },
        {
          name: "跟进结果",
          id: "come_status",
        },
        {
          name: "产后客户类型",
          id: "chankang_type_text",
          disabled: false,
        },
        {
          name: "跟进门店",
          id: "follow_store_list",
          disabled: true,
        },
        {
          name: "本门店分组",
          id: "my_store_group_list",
          disabled: true,
        },
        {
          name: "用户类型",
          id: "member_type",
        },
        {
          name: "预产期",
          id: "child_birth",
        },
        {
          name: "咨询日期",
          id: "consult_time",
        },
        {
          name: "本门店跟进人",
          id: "follow_list",
        },
        {
          name: "我的跟进状态",
          id: "follow_status",
        },
        {
          name: "我的分配时间",
          id: "allot_time",
        },
        {
          name: "渠道",
          id: "channel_info_list",
        },
        {
          name: "录入人员",
          id: "agent_name_list",
        },
        {
          name: "录入时间",
          id: "enter_time",
        },
        {
          name: "身份证",
          id: "id_card",
        },
        {
          name: "性别",
          id: "sex_text",
        },
        {
          name: "所在区域",
          id: "region",
        },
        {
          name: "详细信息",
          id: "address",
        },
        {
          name: "备注",
          id: "remark",
        },
        {
          name: "下次回访时间",
          id: "next_visit_time",
        },
        {
          name: "渠道说明",
          id: "channel_explain",
        },
        {
          name: "录入方式",
          id: "insert_way",
        },
      ],
      t_columns: [
        {
          type: "selection",
          width: 60,
          align: "center",
        },
        {
          title: "ID",
          key: "id",
          align: "center",
        },
        {
          title: "姓名",
          key: "name",
          align: "center",
          render: (h, params) => {
            const name = params.row.name;
            const total = params.row.member_return_task_relevances_count;
            const count = total >= 99 ? "99+" : total;
            this.userName = name;
            let show = total != 0 ? "inline-block" : "none";
            let arr = [];
            let moke = params.row.member_return_task_relevances;
            if (moke.length) {
              moke.map((item, index) => {
                if (item != null) {
                  var obj = h("div", { style: { margin: "5px 0" } }, [
                    h(
                      "div",
                      { style: { fontWeight: "600", fontSize: "14px" } },
                      "回访任务 " + (index + 1) + " " + item.task_name
                    ),
                    h("div", { style: { fontSize: "12px" } }, item.desc),
                    h(
                      "div",
                      { style: { fontSize: "12px" } },
                      "任务日期" + item.updated_at
                    ),
                  ]);
                  arr.push(obj);
                }
              });
            }
            return h(
              "div",
              { style: { display: "flex", justifyContent: "space-between" } },
              [
                h(
                  "div",
                  { style: { textAlign: "center", width: "70%" } },
                  name
                ),
                h(
                  "Tooltip",
                  {
                    props: {
                      maxWidth: "600",
                      placement: "right",
                      transfer: true,
                    },
                    style: {
                      textAlign: "center",
                      background: "#fd9807",
                      color: "#fff",
                      margin: "0 6px",
                      borderRadius: "22px",
                      cursor: "pointer",
                      width: "22px",
                      height: "22px",
                      lineHeight: "22px",
                      display: show,
                    },
                  },
                  [
                    h(
                      "div",
                      {
                        slot: "content",
                        style: {
                          color: "#fff",
                          whiteSpace: "pre-wrap",
                        },
                      },
                      arr
                    ),
                    h("span", {}, count),
                  ]
                ),

                // h('div',{
                //     style:{textAlign: 'center',background:'#fd9807',
                //     color:'#fff',padding:'0 6x',borderRadius:'24px',
                //     cursor:'pointer',width:'24px',height:'24px',lineHeight:'24px',
                //     display:show},
                //     on:{
                //         click: () => {
                //             this.userName=name;
                //             this.apigetUserNotReturnDetail(params.row.id);
                //         }
                //     }},count)
              ]
            );
          },
        },
        {
          title: "手机号",
          key: "phone",
          align: "center",
          width: 140,
          render: (h, params) => {
            const phone = params.row.phone;
            return h("div", [
              h("span", { style: { textAlign: "center" } }, phone),
              h("Button", {
                props: {
                  type: "text",
                  icon: "ios-paper-outline",
                },
                on: {
                  click: () => {
                    this.copy(phone);
                  },
                },
              }),
            ]);
          },
        },
        {
          title: "当前状态",
          key: "member_status",
          align: "center",
        },
        {
          title: "跟进结果",
          align: "center",
          key: "come_status",
          // width:180,
        },
        {
          title: "产后客户类型",
          key: "chankang_type_text",
          align: "center",
          // width:180,
        },
        {
          title: "跟进门店",
          key: "follow_store_list",
          align: "center",
          render: (h, params) => {
            let follow_store_list = params.row.follow_store_list;
            let html = "";
            let index = 0;
            for (let item of follow_store_list) {
              if (follow_store_list.length == 1) {
                html += item;
              } else {
                index++;
                if (item != null) {
                  html += index + "." + item + "\n";
                }
              }
            }
            return h("div", [h("div", {}, html)]);
          },
        },
        {
          title: "本门店分组",
          key: "my_store_group_list",
          align: "center",
          render: (h, params) => {
            let follow_list = params.row.my_store_group_list;
            let html = "";
            let index = 0;
            for (let item of follow_list) {
              if (follow_list.length == 1) {
                html += item;
              } else {
                index++;
                html += index + "." + item + "\n";
              }
            }
            return h("div", [h("div", {}, html)]);
          },
        },
        {
          title: "用户类型",
          key: "member_type",
          align: "center",
        },
        {
          title: "预产期",
          key: "child_birth",
          align: "center",
          sortable: "custom",
          render: (h, params) => {
            let child_birth = params.row.child_birth[0];
            return h("div", [h("div", {}, child_birth)]);
          },
        },
        {
          title: "咨询日期",
          key: "consult_time",
          align: "center",
          sortable: "custom",
        },
        {
          title: "本门店跟进人",
          key: "follow_list",
          align: "center",
          render: (h, params) => {
            let follow_list = params.row.follow_list;
            let html = "";
            let index = 0;
            for (let item of follow_list) {
              if (follow_list.length == 1) {
                html += item;
              } else {
                index++;
                html += index + "." + item + "\n";
              }
            }
            return h("div", [h("div", {}, html)]);
          },
        },
        {
          title: "我的跟进状态",
          key: "follow_status",
          align: "center",
          sortable: "custom",
          //  width:180,
          render: (h, params) => {
            let follow_status = params.row.follow_status;
            var arr = [];
            for (var i = 0; i < follow_status.length; i++) {
              var color = "";
              var objStyle = {};
              switch (follow_status[i]) {
                case "未回访":
                  objStyle = {
                    props: { color: "#7093DB" },
                    style: { height: "auto", textAlign: "center" },
                  };
                  break;
                case "当天需回访":
                  objStyle = {
                    props: { color: "#FF7F00" },
                    style: { height: "auto", textAlign: "center" },
                  };
                  break;
                case "逾期未回访":
                  objStyle = {
                    props: { color: "#FF2400" },
                    style: { height: "auto", textAlign: "center" },
                  };
                  break;
                default:
                  objStyle = { style: { height: "auto", textAlign: "center" } };
              }
              if (follow_status.length == 1) {
                arr.push(h("Tag", objStyle, follow_status[i]));
              } else {
                arr.push(h("Tag", objStyle, i + 1 + "." + follow_status[i]));
              }
            }
            return h("div", arr);
          },
        },
        {
          title: "我的分配时间",
          key: "allot_time",
          align: "center",
          sortable: "custom",
          render: (h, params) => {
            let allot_time = params.row.allot_time[0];
            return h("div", [h("div", {}, allot_time)]);
          },
        },
        {
          title: "渠道",
          key: "channel_info_list",
          align: "center",
          render: (h, params) => {
            let channel_info_list = params.row.channel_info_list;
            let html = "";
            let index = 0;
            for (let item of channel_info_list) {
              if (channel_info_list.length == 1) {
                html += item;
              } else {
                index++;
                html += index + "." + item + "\n";
              }
            }
            return h("div", [h("div", {}, html)]);
          },
        },
        {
          title: "录入人员",
          key: "agent_name_list",
          align: "center",
          render: (h, params) => {
            let agent_name_list = params.row.agent_name_list;
            let html = "";
            let index = 0;
            for (let item of agent_name_list) {
              if (agent_name_list.length == 1) {
                html += item;
              } else {
                index++;
                html += index + "." + item + "\n";
              }
            }
            return h("div", [h("div", {}, html)]);
          },
        },
        {
          title: "录入时间",
          key: "enter_time",
          sortable: "custom",
          align: "center",
          render: (h, params) => {
            let enter_time = params.row.enter_time;
            let html = "";
            let index = 0;
            for (let item of enter_time) {
              if (enter_time.length == 1) {
                html += item;
              } else {
                index++;
                html += index + "." + item + "\n";
              }
            }
            return h("div", [h("div", {}, html)]);
          },
        },
        {
          title: "身份证",
          key: "id_card",
          align: "center",
        },
        {
          title: "性别",
          key: "sex_text",
          align: "center",
        },
        {
          title: "所在区域",
          key: "region",
          align: "center",
        },
        {
          title: "详细地址",
          key: "address",
          align: "center",
        },
        {
          title: "备注",
          key: "remark",
          align: "center",
        },
        {
          title: "下次回访时间",
          key: "next_visit_time",
          align: "center",
          sortable: "custom",
        },
        {
          title: "渠道说明",
          key: "channel_explain",
          align: "center",
          render: (h, params) => {
            let channel_explain = params.row.channel_explain[0];
            return h("div", [h("div", {}, channel_explain)]);
          },
        },
        {
          title: "录入方式",
          key: "insert_way",
          align: "center",
          render: (h, params) => {
            let insert_way = params.row.insert_way[0];
            return h("div", [h("div", {}, insert_way)]);
          },
        },
        {
          title: "操作",
          key: "action",
          width: 100,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  on: {
                    click: () => {
                      this.detail(params.row);
                    },
                  },
                },
                "客户详情"
              ),
            ]);
          },
        },
      ],
      t_data: [],
      pagination: {},
      customerInfoDetailId: {}, //客户详情ID
      storeList: [],
      departmentList: [],
      followDepartmentList: [],
      channel: [],
      followr: [],
      selection: [], //checkbox选中的数据
      maternal_info_id: "", //孕妇ID
      paymentIntentionSrc: "",
      export_table_data: [],
    };
  },
  created() {
    this.apiStoreAll();
    //created获取缓存表格自选项数据，更新表格
    let get_my_customer_table_columns = Lockr.get("my_customer_table_columns");
    if (get_my_customer_table_columns) {
      this.defaultTable = get_my_customer_table_columns;
    }
    let getFormItem = JSON.parse(localStorage.getItem("formItem"));

    let get_member_group = [];
    if (getFormItem) {
      if (getFormItem.enter_department_id != "")
        this.apiChannelAll(getFormItem.enter_department_id);
      if (getFormItem.follow_store_id != "")
        this.apiDepartmentAll(getFormItem.follow_store_id);
      if (getFormItem.follow_department_id != "")
        this.apiFollowr(
          getFormItem.follow_department_id,
          getFormItem.follow_store_id
        );
      this.formItem = getFormItem;
      get_member_group = getFormItem.member_group;
    }
    this.apiGetMemberGroupList(get_member_group);
    this.apiDepartmentAll();
    if (this.isUpdateTable) {
      this.apiCustomerList();
    }
  },
  mounted() {
    this.tableHeight =
      window.innerHeight - this.$refs.table.$el.offsetTop - 255;
  },
  methods: {
    watchUpdate(val, member_id, nokown, isUpload) {
      console.log(val);
      if (val) {
        this.isUpdateTable = false;
      }
      console.log("member_id", member_id);
      if (member_id) {
        this.apigetMemberDetail(member_id);
      }
      if (!isUpload) {
        this.uploadReturn = false;
      }
    },
    //获取客户未回访的任务列表
    apigetUserNotReturnDetail(id) {
      serve
        .fetchGet(api.myMembergetMemberReturnTaskList + "/" + id, {})
        .then((data) => {
          console.log("未完成的回访任务", data);
          let res = data.data;
          this.returnTaskList = res;
          // this.showUnfinishedTask=true;
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    //获取回访任务条数
    apigetNotReturnTotal() {
      serve
        .fetchGet(api.myMembergetMyMemberStatusReturnTaskCount, {})
        .then((data) => {
          console.log("获取回访任务条数", data);
          let res = data.data;
          this.complete = res.order_delay_return_task_count;
          this.sign = res.already_sign_return_task_count;
          this.giveup = res.already_abandon_return_task_count;
          this.loading = false;
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    changeTabs(name) {
      // if(!name==this.current){
      switch (name) {
        case "complete":
          this.formItem.my_member_list_type = "1";
          break;
        case "sign":
          this.formItem.my_member_list_type = "2";
          break;
        case "giveup":
          this.formItem.my_member_list_type = "3";
          break;
      }
      this.selection = [];
      this.member_ids = [];
      this.formItem.page = 1;
      this.apiCustomerList();
      // }
    },
    getComplete() {
      return this.complete;
    },
    getSign() {
      return this.sign;
    },
    getGiveup() {
      return this.giveup;
    },
    //导出客户
    excelCustomer() {
      this.excelTitle = "导出客户Excel";
      this.excelSteps = 1;
      this.customerExcelShow = true;
    },
    //导出回访
    exportReturnRecord() {
      this.excelTitle = "导出回访记录";
      this.excelSteps = 1;
      this.customerExcelShow = true;
    },
    packUp() {
      this.moreSearch = false;
      this.tableHeight =
        window.innerHeight - this.$refs.table.$el.offsetTop - 90;
    },
    screening() {
      this.moreSearch = true;
      this.tableHeight =
        window.innerHeight - this.$refs.table.$el.offsetTop - 340;
    },
    apiCustomerList(excel_title, excel_params) {
      let params = {
        limit: this.formItem.limit,
        page: this.formItem.page, //分页
        keywords: this.formItem.keywords, //客户搜索-过滤客户姓名/手机号
        enter_agent: this.formItem.enter_agent, //录入人
        enter_department_id: this.formItem.enter_department_id, //渠道部门id
        enter_channel_id: this.formItem.enter_channel_id, //渠道id
        member_group: this.formItem.member_group, //客户分组
        member_type_id: this.formItem.member_type_id, //用户类型
        insert_way_id: this.formItem.insert_way_id, //录入方式
        follow_store_id: this.formItem.follow_store_id, //跟进人门店
        follow_department_id: this.formItem.follow_department_id, //跟进人部门
        follow_agent_id: this.formItem.follow_agent_id, //跟进人
        follow_status_id: this.formItem.follow_status_id, //跟进状态
        child_birth_start:
          this.formItem.child_birth.length == 0
            ? ""
            : util.dateFormat(this.formItem.child_birth[0]), //预产期开始时间
        child_birth_end:
          this.formItem.child_birth.length == 0
            ? ""
            : util.dateFormat(this.formItem.child_birth[1]), //预产期结束时间
        consult_time_start:
          this.formItem.consult_time.length == 0
            ? ""
            : util.dateFormat(this.formItem.consult_time[0]), //咨询开始时间
        consult_time_end:
          this.formItem.consult_time.length == 0
            ? ""
            : util.dateFormat(this.formItem.consult_time[1]), //咨询结束时间
        enter_time_start:
          this.formItem.enter_time.length == 0
            ? ""
            : util.dateFormat(this.formItem.enter_time[0]), //录入开始时间
        enter_time_end:
          this.formItem.enter_time.length == 0
            ? ""
            : util.dateFormat(this.formItem.enter_time[1]), //录入结束时间
        agent_time_start:
          this.formItem.agent_time.length == 0
            ? ""
            : util.dateFormat(this.formItem.agent_time[0]), //分配开始时间
        agent_time_end:
          this.formItem.agent_time.length == 0
            ? ""
            : util.dateFormat(this.formItem.agent_time[1]), //分配结束时间
        visit_time_start:
          this.formItem.last_visit_time.length == 0
            ? ""
            : util.dateFormat(this.formItem.last_visit_time[0]), //下次回访开始时间
        visit_time_end:
          this.formItem.last_visit_time.length == 0
            ? ""
            : util.dateFormat(this.formItem.last_visit_time[1]), //下次回访结束时间
        first_enter_id: this.formItem.first_enter_id === true ? 1 : "", //首次录入时间
        sort: this.formItem.sort,
        come_status_id: this.formItem.come_status_id,
        my_member_list_type: this.formItem.my_member_list_type,
        chankang_type: this.formItem.chankang_type,
      };
      let url = api.getMyMemberListNew;
      if (excel_title == "导出客户Excel") {
        url = api.myMemberExport;
        this.$Message.loading({
          content: "正在获取导出链接",
          duration: 100,
        });
        if (excel_params.value == 1) {
          params.email = excel_params.mail; //按筛选条件导出传参
        } else if (excel_params.value == 2) {
          params = {
            email: excel_params.mail, //按全部导出传参
          };
        }
        params.channel_info_sort = excel_params.channel_info_sort;
      } else if (excel_title == "导出回访记录") {
        this.$Message.loading({
          content: "正在获取导出链接",
          duration: 100,
        });
        url = api.myMemberVisitExport;
        if (excel_params.value == 1) {
          params.email = excel_params.mail; //按筛选条件导出传参
        } else if (excel_params.value == 2) {
          params = {
            email: excel_params.mail, //按全部导出传参
          };
        }
      } else {
        this.loading = true;
      }
      serve
        .fetchGet(url, params)
        .then((data) => {
          console.log(data);
          //导出客户
          if (excel_title == "导出客户Excel") {
            this.$Message.destroy();
            this.downloadLink = data.url;
            this.excelSteps = 2;
            this.customerExcelShow = true;
            return;
          }
          //导出回访
          if (excel_title == "导出回访记录") {
            this.$Message.destroy();
            this.downloadLink = data.url;
            this.excelSteps = 2;
            this.customerExcelShow = true;
            return;
          }

          for (var i = 0; i < data.data.length; i++) {
            var item = data.data[i];
            item.come_status = item.come_status.length
              ? item.come_status
                  .map((val, i, arr) => {
                    if (arr.length != 1) {
                      return i + 1 + "." + val;
                    } else {
                      return val;
                    }
                  })
                  .join("\n")
              : "";
          }
          this.t_data = data.data;
          this.pagination = data.meta.pagination;
          this.apigetNotReturnTotal();
        })
        .catch((error) => {
          this.loading = false;
          this.$Message.destroy();
          this.$Message.error(error.response.data.message);
        });
    },
    apiGetMemberGroupList(group) {
      serve
        .fetchGet(api.myMemberGroupAll, {})
        .then((data) => {
          console.log(data);
          this.customerGroudList = data.member_groups;
          let getGroupName = [];
          if (group.length) {
            for (let item of data.member_groups) {
              for (let val of group) {
                if (item.id == val) {
                  getGroupName.push(item.name);
                }
              }
            }
          }
          this.checkedShowValue = getGroupName.join(",");
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    apiStoreAll() {
      serve
        .fetchGet(api.myMemberStoreAll, {})
        .then((data) => {
          console.log(data);
          this.storeList = data.data;
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    apiDepartmentAll(store_id) {
      let params = {};
      if (store_id) {
        params.store_id = store_id;
      }
      serve
        .fetchGet(api.myMemberDepartmentAll, params)
        .then((data) => {
          console.log(data);
          if (store_id) {
            this.followDepartmentList = data.data;
          } else {
            this.departmentList = data.data;
          }
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    apiChannelAll(id) {
      serve
        .fetchGet(api.myMemberChannelAll, { department_id: id })
        .then((data) => {
          console.log("渠道", data);
          this.channel = data.data;
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    //监听放弃跟进模态框
    giveUpFollowEven(val, success) {
      this.giveUpFollowShow = val;
      if (success) {
        this.customerDrawer = false;
        this.formItem.page = 1;
        this.apiCustomerList();
      }
    },
    relevanceEven(val, upload) {
      this.relevanceShow = val;
      if (upload) {
        this.uploadReturn = upload;
      }
    },
    //点击客户详情
    detail(row) {
      console.log(row);
      this.isUpdateTable = true;
      this.customerDrawer = true;
      this.customerInfoDetailId = row.id;
      this.apigetMemberDetail(row.id);
    },
    //获取客户基本信息
    apigetMemberDetail(id) {
      this.maternal_info_id = "";
      this.member_id = "";
      serve
        .fetchGet(api.myMemberGetMemberDetail + "/" + id, {})
        .then((data) => {
          console.log("获取客户基本信息", data);
          let detail = data.data;
          for (let i = 0; i < detail.maternal_info_list.length; i++) {
            if (detail.maternal_info_list[i].use_state == 1) {
              this.maternal_info_id =
                detail.maternal_info_list[i].maternal_info_id;
              this.member_id = detail.id;
            }
          }
        })
        .catch((error) => {
          // this.$Message.error(error.response.data.message);
        });
    },
    //查询首次录入时间
    searchFirstTime(status) {
      console.log(status);
    },
    //监听选择渠道部门
    changeChannel(id) {
      this.formItem.channel_id = "";
      this.channel = [];
      this.apiChannelAll(id);
    },
    //监听分页
    changePage(page) {
      this.formItem.page = page;
      this.apiCustomerList();
    },
    changeLimit(val) {
      this.formItem.page = 1;
      this.formItem.limit = val;
      this.apiCustomerList();
    },
    //监听跟进人门店
    changeStoreFollow(id) {
      (this.formItem.follow_department_id = ""), //跟进人部门
        (this.formItem.follow_agent_id = ""), //跟进人
        (this.followDepartmentList = []);
      this.apiDepartmentAll(id);
    },
    //监听跟进人部门
    changeDepartmentFollow(id) {
      (this.formItem.follow_agent_id = ""), //跟进人
        (this.followr = []);
      this.apiFollowr(id);
    },
    //获取跟进人
    apiFollowr(departmentId, storeId) {
      let params = {
        department_id: departmentId,
        store_id:
          this.formItem.follow_store_id == ""
            ? storeId
            : this.formItem.follow_store_id,
      };
      serve
        .fetchGet(api.myMemberAgentAll, params)
        .then((data) => {
          console.log("跟进人", data);
          this.followr = data.data;
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    //查询
    search() {
      this.formItem.page = 1;
      this.selection = [];
      this.member_ids = [];
      localStorage.setItem("formItem", JSON.stringify(this.formItem));
      this.apiCustomerList();
    },
    //清空筛选
    reset() {
      localStorage.clear();
      this.$refs.formValidate.resetFields();
      this.formItem.keywords = "";
      this.formItem.page = 1;
      (this.formItem.enter_agent = ""), //录入人
        (this.formItem.enter_department_id = ""), //渠道部门id
        (this.formItem.enter_channel_id = ""), //渠道id
        (this.formItem.member_group = []), //客户分组
        (this.formItem.member_type_id = ""), //用户类型
        (this.formItem.insert_way_id = ""), //录入方式
        (this.formItem.follow_store_id = ""), //跟进人门店
        (this.formItem.follow_department_id = ""), //跟进人部门
        (this.formItem.follow_agent_id = ""), //跟进人
        (this.formItem.follow_status_id = ""), //跟进状态
        (this.formItem.child_birth = []), //预产期
        (this.formItem.consult_time = []), //咨询时间
        (this.formItem.enter_time = []), //录入时间
        (this.formItem.agent_time = []), //分配时间
        (this.formItem.last_visit_time = []), //下次回访时间
        (this.formItem.come_status_id = "");
      this.selection = [];
      this.member_ids = [];
      this.checkedShowValue = "";
      this.formItem.sort = {};
      this.formItem.first_enter_id = false;
      this.formItem.chankang_type = "";
      this.apiCustomerList();
    },
    // 复制
    copy(copyInfo) {
      let oInput = document.createElement("input");
      oInput.value = copyInfo;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("Copy");
      oInput.style.display = "none";
      document.body.removeChild(oInput);
      this.$Message.success("复制成功");
    },
    //监听表格checkbox
    selecstionChange(selection) {
      this.selection = selection;
      this.member_ids = selection;
    },
    //放弃跟进
    giveUpFollow() {
      if (this.member_ids.length) {
        this.giveUpFollowType = "all";
        this.giveUpFollowShow = true;
      } else {
        this.$Message.warning("请勾选至少一条");
      }
    },
    //详情里面的放弃跟进
    giveUpFollowDetail() {
      this.giveUpFollowType = "one";
      this.member_ids = [{ id: this.customerInfoDetailId }];
      this.giveUpFollowShow = true;
    },
    //关联客户
    relevanceCustomer() {
      this.relevanceShow = true;
    },
    //申请折扣
    applyDiscount() {
      let src =
        api.erpUrl +
        "/index.php/Crm/ReturnWork/discount_apply?id=" +
        this.customerInfoDetailId;
      window.open(src, "_blank");
    },
    //收取意向金
    paymentIntention() {
      if (!this.maternal_info_id) {
        this.$Message.warning("请添加孕妇信息");
        return;
      }
      let src = "";
      if (this.maternal_info_id) {
        src =
          api.erpUrl +
          "/index.php/Shixin2/Member/add_intention?maternal_id=" +
          this.maternal_info_id;
      } else {
        src =
          api.erpUrl +
          "/index.php/Shixin2/Member/add_intention?member_id=" +
          this.customerInfoDetailId;
      }
      window.open(src, "_blank");
    },
    //创建预订单
    createOrderTotal() {
      if (!this.maternal_info_id) {
        this.$Message.warning("请添加孕妇信息");
        return;
      }
      let src =
        api.erpUrl +
        "/index.php/Shixin2/Order/create_order_total.html?id=" +
        this.maternal_info_id;
      window.open(src, "_blank");
    },
    //关闭客户详情
    close() {
      this.customerDrawer = false;
      this.apiCustomerList();
    },
    //监听客户分组
    member_group_even(data, checkedShowValue) {
      console.log(data);
      console.log(checkedShowValue);
      this.formItem.member_group = data;
      this.checkedShowValue = checkedShowValue;
    },
    //添加客户
    addMember() {
      this.apiAddMemberAuth();
    },
    //新增客户权限
    apiAddMemberAuth(create_type) {
      // let url = this.type == 'myCustomer' ? api.myMemberAddMemberBtn : api.memberAddMemberBtn
      serve
        .fetchGet(api.myMemberAddMemberBtn, {})
        .then((data) => {
          console.log("新增客户权限", data);
          if (data[0]) {
            this.$router.push({
              //核心语句
              path: "/addMember?type=myCustomer",
            });
          }
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    //监听导出客户/回访
    customerExcelEven(val, is_export, params, title) {
      this.customerExcelShow = val;
      if (is_export) {
        this.formItem.page = 1;
        this.selection = [];
        this.member_ids = [];
        this.apiCustomerList(title, params);
      }
    },
    //表格排序
    sortTable(column) {
      console.log(column);
      if (column.order != "normal") {
        switch (column.column.title) {
          case "我的分配时间":
            this.formItem.sort.sort = column.order;
            this.formItem.sort.field = "follows_created_at";
            break;
          case "我的跟进状态":
            this.formItem.sort.sort = column.order;
            this.formItem.sort.field = "follows_follow_status";
            break;
          case "咨询日期":
            this.formItem.sort.sort = column.order;
            this.formItem.sort.field = "members_consult_time";
            break;
          case "预产期":
            this.formItem.sort.sort = column.order;
            this.formItem.sort.field = "maternal_infos_child_birth";
            break;
          case "下次回访时间":
            this.formItem.sort.sort = column.order;
            this.formItem.sort.field = "visits_visit_time";
            break;
          case "录入时间":
            this.formItem.sort.sort = column.order;
            this.formItem.sort.field = "channel_infos_created_at";
            break;
        }
        this.apiCustomerList();
      }
    },
    //监听表格自选
    autoTableRef(data) {
      console.log(data);
      Lockr.set("my_customer_table_columns", data);
      let getTableHead = [this.t_columns[0], this.t_columns[1]];
      for (let item of data) {
        switch (item) {
          case "name":
            getTableHead.push(this.t_columns[2]);
            break;
          case "phone":
            getTableHead.push(this.t_columns[3]);
            break;
          case "member_status":
            getTableHead.push(this.t_columns[4]);
            break;
          case "come_status":
            getTableHead.push(this.t_columns[5]);
            break;
          case "chankang_type_text":
            getTableHead.push(this.t_columns[6]);
            break;
          case "follow_store_list":
            getTableHead.push(this.t_columns[7]);
            break;
          case "my_store_group_list":
            getTableHead.push(this.t_columns[8]);
            break;
          case "member_type":
            getTableHead.push(this.t_columns[9]);
            break;
          case "child_birth":
            getTableHead.push(this.t_columns[10]);
            break;
          case "consult_time":
            getTableHead.push(this.t_columns[11]);
            break;
          case "follow_list":
            getTableHead.push(this.t_columns[12]);
            break;
          case "follow_status":
            getTableHead.push(this.t_columns[13]);
            break;
          case "allot_time":
            getTableHead.push(this.t_columns[14]);
            break;
          case "channel_info_list":
            getTableHead.push(this.t_columns[15]);
            break;
          case "agent_name_list":
            getTableHead.push(this.t_columns[16]);
            break;
          case "enter_time":
            getTableHead.push(this.t_columns[17]);
            break;
          case "id_card":
            getTableHead.push(this.t_columns[18]);
            break;
          case "sex_text":
            getTableHead.push(this.t_columns[19]);
            break;
          case "region":
            getTableHead.push(this.t_columns[20]);
            break;
          case "address":
            getTableHead.push(this.t_columns[21]);
            break;
          case "remark":
            getTableHead.push(this.t_columns[22]);
            break;
          case "next_visit_time":
            getTableHead.push(this.t_columns[23]);
            break;
          case "channel_explain":
            getTableHead.push(this.t_columns[24]);
            break;
          case "insert_way":
            getTableHead.push(this.t_columns[25]);
            break;
          // case "next_visit_time":
          //     getTableHead.push(this.t_columns[24])
          //     break;
          // case "next_visit_content":
          //     getTableHead.push(this.t_columns[25])
          //     break;
        }
      }
      getTableHead.push(this.t_columns[26]);
      this.table_columns = getTableHead;
    },
  },
};
</script>
<style scoped>
.page {
  display: flex;
  justify-content: flex-end;
}
.customerDetailContent {
  display: flex;
  display: -webkit-flex;
  height: calc(100vh - 129px);
  overflow: auto;
}
.customerDetailContent .content:nth-child(1) {
  border-right: 1px solid #eee;
}
.customerDetailContent .content {
  flex: 1;
  padding: 0 10px;
}
.mb-10 {
  margin-bottom: 10px;
}
.customerDetailContent_opertion_btn {
  text-align: center;
  margin-top: 10px;
}
.opertionBtn_search {
  display: flex;
  display: -webkit-flex;
  align-items: center;
}
.opertionBtn .item {
  margin-right: 5px;
}
.topBtn {
  display: flex;
  justify-content: flex-end;
  padding-bottom: 10px;
  border-bottom: 1px solid #e8eaec;
  padding-top: 10px;
  padding-right: 5px;
  background: rgba(249, 249, 249);
}
.topBtn .item {
  margin-left: 5px;
}
.opertionBtn_search .item {
  margin-right: 5px;
}
.header_search {
  border: 1px solid #e8eaec;
}
.table_style .ivu-table-cell {
  padding-left: 2px;
  padding-right: 2px;
}
.modal_title {
  text-align: center;
}
.modal_text {
  font-size: 14px;
  margin: 12px 0;
  font-weight: 500;
  color: #464c5b;
}
.card_wrap {
  margin-bottom: 10px;
}
.card_con {
  /* display:flex;
        justify-content:space-between; */
}
.TabsBtn {
  margin: 2px 0px 0px 4px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Crm/UserManagement/myCustomerNew.vue